module.exports = __webpack_public_path__ + "img/star-black.299b4c6d.svg";